import { absoluteUrl } from '@/platform/lib/urls';
import { isLoopbackUrl } from '@/platform/lib/loopbackUrl';

const isProduction = process.env.NODE_ENV === 'production';

function requireNonLoopback(name: string, value: string): string {
  if (isProduction && isLoopbackUrl(value)) {
    throw new Error(
      `${name} must not point at localhost in production (got ${value}). ` +
        'Use the correct production env profile (.env.production.paydirt / ops / tenant) without .env.local overriding it ' +
        '(deploy-web-firebase.ps1 moves .env.local aside automatically).',
    );
  }
  return value;
}

function resolveSiteUrl(): string {
  const fromEnv = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  if (fromEnv) return requireNonLoopback('NEXT_PUBLIC_SITE_URL', fromEnv);
  if (isProduction) {
    throw new Error('NEXT_PUBLIC_SITE_URL is required for production builds (activate a profile into web/.env.production).');
  }
  return 'http://localhost:3000';
}

function resolveApiBaseUrl(): string {
  const fromEnv = process.env.NEXT_PUBLIC_API_URL?.trim();
  if (fromEnv) return requireNonLoopback('NEXT_PUBLIC_API_URL', fromEnv);
  return isProduction ? '/api' : 'http://localhost:8080';
}

/**
 * Per-deployment site wiring (env at build time).
 * Platform code must not import this — use absoluteUrl() with a passed base instead.
 */
export const siteConfig = {
  siteUrl: resolveSiteUrl(),
  siteName: process.env.NEXT_PUBLIC_SITE_NAME || (isProduction ? 'Site' : 'Dev Site'),
  apiBaseUrl: resolveApiBaseUrl(),
};

export function siteUrl(path: string): string {
  return absoluteUrl(siteConfig.siteUrl, path);
}
